module.exports = __webpack_public_path__ + "assets/bb8842c3432ea2c87fc8ae29e01a11c2.jpg";